import { createSlice } from '@reduxjs/toolkit';
import {
  getCustomerDetail,
  getCustomerObject,
  getCustomers,
  getCustomerVoucherOverview,
} from './thunk';

export const initialState = {
  customers: [],
  customersTotal: 0,
  currentCustomer: {},
  customerObject: [],
  customerObjectTotal: 0,
  customerVoucherOverview: [],
  customerVoucherOverviewTotal: 0,
};

const CustomerSlice = createSlice({
  name: 'Customers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomers.fulfilled, (state: any, action: any) => {
      state.customers = action.payload?.data || [];
      state.customersTotal = Number(action.payload?.total || 0);
    });
    builder.addCase(getCustomerDetail.fulfilled, (state: any, action: any) => {
      state.currentCustomer = action.payload;
    });
    builder.addCase(getCustomerObject.fulfilled, (state: any, action: any) => {
      state.customerObject = action.payload?.data || [];
      state.customerObjectTotal = Number(action.payload?.total || 0);
    });
    builder.addCase(getCustomerVoucherOverview.fulfilled, (state: any, action: any) => {
      state.customerVoucherOverview = action.payload?.data || [];
      state.customerVoucherOverviewTotal = Number(action.payload?.total || 0);
    });
  },
});

export default CustomerSlice.reducer;
